import * as React from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";

import { cn } from "@/lib/utils";

function Popover({
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Root>) {
  return <PopoverPrimitive.Root data-slot="popover" {...props} />;
}

function PopoverTrigger({
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Trigger>) {
  return <PopoverPrimitive.Trigger data-slot="popover-trigger" {...props} />;
}

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, align = "center", sideOffset = 4, ...props }, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      data-slot="popover-content"
      align={align}
      sideOffset={sideOffset}
      className={cn(
        "aero:bg-popover aero:text-popover-foreground aero:data-[state=open]:animate-in aero:data-[state=closed]:animate-out aero:data-[state=closed]:fade-out-0 aero:data-[state=open]:fade-in-0 aero:data-[state=closed]:zoom-out-95 aero:data-[state=open]:zoom-in-95 aero:data-[side=bottom]:slide-in-from-top-2 aero:data-[side=left]:slide-in-from-right-2 aero:data-[side=right]:slide-in-from-left-2 aero:data-[side=top]:slide-in-from-bottom-2 aero:z-50 aero:w-72 aero:origin-(--radix-popover-content-transform-origin) aero:!rounded-md aero:border aero:border-neutral-300 aero:p-4 aero:shadow-md aero:outline-hidden",
        className
      )}
      {...props}
    />
  </PopoverPrimitive.Portal>
));
PopoverContent.displayName = "PopoverContent";

function PopoverAnchor({
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Anchor>) {
  return <PopoverPrimitive.Anchor data-slot="popover-anchor" {...props} />;
}

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor };
